/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconUserSearch = createReactComponent("user-search", "IconUserSearch", [
  ["path", { d: "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0", key: "svg-0" }],
  ["path", { d: "M6 21v-2a4 4 0 0 1 4 -4h1.5", key: "svg-1" }],
  ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-3" }]
]);

export { IconUserSearch as default };
//# sourceMappingURL=IconUserSearch.js.map
